import React from "react";
import One from "../assets/1.svg";
import Two from "../assets/2.svg";
import Three from "../assets/3.svg";
import Four from "../assets/4.svg";
import Five from "../assets/5.svg";
import Six from "../assets/6.svg";

const data = [
  [
    {
      image: {One},
      title: "Smart Electricity Metering System",
      date: "",
      description: "• Automated metering system with bill generation, payment reminders. • Secured payments system using Blockchain technology. • Minimized the manual labor of electricity meter-readers.",
      stack: "",
      href: "https://github.com/yathin017/Smart-Electricity-Meter",
    },
    {
      image: {Two},
      title: "Metaverse based E-Commerce",
      date: "",
      description: "• E-Commerce platform with avatar creation feature for users. • Product interaction and NFT-based warranty for purchased products. • Text and voice chat feature for communication with other customers.",
      stack: "",
      href: "https://github.com/yathin017/Metakart",
    },
  ],
  [
    {
      image: {Three},
      title: "ZK Meta Wallet",
      date: "",
      description: "• Wallet with a focus on security and safety for users. • Utilized zero knowledge protocol for enhanced security. • Secure platform for storing and managing digital assets.",
      stack: "",
      href: "https://github.com/yathin017/MetaWallet",
    },
    {
      image: {Four},
      title: "Advanced KYC Verification",
      date: "",
      description: "• Secure and efficient process for verifying useridentities. • Useridentity validation using computer vision",
      stack: "",
      href: "https://github.com/yathin017/Customer-Due-Diligence",
    },
  ],
  [
    {
      image: {Five},
      title: "Fruit Warehouse Management",
      date: "",
      description: "• Developed a fruit segregation system based on quality and size. • Monitoring of fruits based on odour, humidity and temperature. • Predicted expiry of fruits for sellers and customers.",
      stack: "",
      href: "https://github.com/yathin017/IoT-Based-Smart-Warehouse-Management-System",
    },
    {
      image: {Six},
      title: "Restaurant Management System",
      date: "",
      description: "",
      stack: "",
      href: "https://github.com/yathin017/Fork-It-Restaurant-Table-Reservation-System",
    },
  ],
];

const Work = () => {
  return (
    <div className="bg-[#0B0F1F] w-full">
      <div className="max-w-[1000px] mx-auto p-4 flex flex-col justify-center w-full h-full scale-95">
        <div>
          <div className="max-w-6xl mx-auto h-48">
            <h1
              name="work"
              className="text-5xl md:text-8xl font-bold py-20 text-center md:text-left text-[#cf6c2f]"
            >
              Work
            </h1>
          </div>
          <p className="text-2xl md:text-3xl text-[#8892b0]">
            # Check some of my recent works
          </p>
        </div>
        <div className="relative container mx-auto px-6 flex flex-col space-y-8">
          <div className="absolute w-2 h-full bg-gray-400 shadow-md inset-0 left-17 md:mx-auto md:right-0 md:left-0"></div>

          {data.map((item) => {
            return (
              <>
                {/* Right */}
                <a href={item[0].href} className="relative z-10">
                  <img
                    src={item[0].image}
                    alt="1"
                    className="w-24 h-24 object-cover rounded-full shadow-md border-4 border-gray-400 self-center xs:absolute md:mx-auto md:right-0 md:left-0"
                  />
                  <div className="relative pt-2 xs:pl-28 xs:pt-0 md:w-1/2 md:ml-auto md:pl-16">
                    <div
                      className="absolute inset-0 left-10 h-4 w-4 transform rotate-45 bg-[#343C5B] xs:top-11 xs:left-26 md:left-14"
                      aria-hidden="true"
                    ></div>
                    <div className="bg-[#343C5B] p-6 rounded-md shadow-md text-gray-300">
                      <h1 className="text-2xl font-bold pt-1">
                        {item[0].title}
                      </h1>
                      <span className="font-bold text-gray-200 text-lg trackng-wide">
                        {item[0].date}
                      </span>
                      <p className="pt-2 text-base">{item[0].description}</p>
                      <p className="pt-2 text-base">{item[0].stack}</p>
                    </div>
                  </div>
                </a>

                {/* Left */}
                <a href={item[1].href} className="relative z-10">
                  <img
                    src={item[1].image}
                    alt="2"
                    className="w-24 h-24 object-cover rounded-full shadow-md border-4 border-gray-400 self-center xs:absolute md:mx-auto md:right-0 md:left-0"
                  />
                  <div className="relative pt-2 xs:pl-28 xs:pt-0 md:w-1/2 md:ml-0 md:mr-auto md:pl-0 md:pr-16">
                    <div
                      className="absolute inset-0 left-10 h-4 w-4 transform rotate-45 bg-[#343C5B] xs:top-11 xs:left-26 md:left-auto md:right-14"
                      aria-hidden="true"
                    ></div>
                    <div className="bg-[#343C5B] p-6 rounded-md shadow-md text-gray-300">
                      <h1 className="text-2xl font-bold pt-1">
                        {item[1].title}
                      </h1>
                      <span className="font-bold text-gray-200 text-lg trackng-wide">
                        {item[1].date}
                      </span>
                      <p className="pt-2 text-base">{item[1].description}</p>
                      <p className="pt-2 text-base">{item[1].stack}</p>
                    </div>
                  </div>
                </a>
              </>
            );
          })}

          {/* Right */}
          {/* <div className="relative z-10">
            <img
              src={Three}
              alt="3"
              className="w-24 h-24 object-cover rounded-full shadow-md border-4 border-gray-400 self-center xs:absolute md:mx-auto md:right-0 md:left-0"
            />
            <div className="relative pt-2 xs:pl-28 xs:pt-0 md:w-1/2 md:ml-auto md:pl-16">
              <div
                className="absolute inset-0 left-10 h-4 w-4 transform rotate-45 bg-[#343C5B] xs:top-11 xs:left-26 md:left-14"
                aria-hidden="true"
              ></div>
              <div className="bg-[#343C5B] p-6 rounded-md shadow-md text-gray-300">
                <h1 className="text-2xl font-bold pt-1">
                  Fruit Warehouse Management
                </h1>
                <span className="font-bold text-gray-200 text-lg trackng-wide">
                  Jan 2022 - Jun 2022
                </span>
                <p className="pt-2 text-base">
                  An automated warehouse will eliminate human error, make
                  storage more efficient and organized. Results in lesser
                  probability of producing wastage and solves 80% problems faced
                  by traditional warehouses.
                </p>
                <p className="pt-2 text-base">
                  Tech Stack - IoT, Computer Vision, ML, Blockchain
                </p>
              </div>
            </div>
          </div> */}

          {/* Left */}
          {/* <div className="relative z-10">
            <img
              src={Four}
              alt="4"
              className="w-24 h-24 object-cover rounded-full shadow-md border-4 border-gray-400 self-center xs:absolute md:mx-auto md:right-0 md:left-0"
            />
            <div className="relative pt-2 xs:pl-28 xs:pt-0 md:w-1/2 md:ml-0 md:mr-auto md:pl-0 md:pr-16">
              <div
                className="absolute inset-0 left-10 h-4 w-4 transform rotate-45 bg-[#343C5B] xs:top-11 xs:left-26 md:left-auto md:right-14"
                aria-hidden="true"
              ></div>
              <div className="bg-[#343C5B] p-6 rounded-md shadow-md text-gray-300">
                <h1 className="text-2xl font-bold pt-1">
                  Fork-It - Restaurant Management System
                </h1>
                <span className="font-bold text-gray-200 text-lg trackng-wide">
                  Dec 2021 - Feb 2022
                </span>
                <p className="pt-2 text-base">
                  Application helps users to check timings, reserve tables, read
                  reviews of restaurants. Payments and reservations use smart
                  contract to establish trust between users and restaurants.
                </p>
                <p className="pt-2 text-base">
                  Tech Stack - MySQL, Blockchain, ReactJS
                </p>
              </div>
            </div>
          </div> */}

          {/* Right */}
          {/* <div className="relative z-10">
            <img
              src={Five}
              alt="5"
              className="w-24 h-24 object-cover rounded-full shadow-md border-4 border-gray-400 self-center xs:absolute md:mx-auto md:right-0 md:left-0"
            />
            <div className="relative pt-2 xs:pl-28 xs:pt-0 md:w-1/2 md:ml-auto md:pl-16">
              <div
                className="absolute inset-0 left-10 h-4 w-4 transform rotate-45 bg-[#343C5B] xs:top-11 xs:left-26 md:left-14"
                aria-hidden="true"
              ></div>
              <div className="bg-[#343C5B] p-6 rounded-md shadow-md text-gray-300">
                <h1 className="text-2xl font-bold pt-1">Project Title</h1>
                <span className="font-bold text-gray-200 text-lg trackng-wide">
                  Month Year
                </span>
                <p className="pt-2 text-base">
                  Lorem ipsum dolor sit amet consectetur adipisicing elit.
                  Ducimus rem tenetur nihil, maiores nisi tempore voluptate
                  nemo, libero voluptates soluta quas deleniti distinctio
                  excepturi illum aliquam expedita recusandae ab dolor?
                </p>
              </div>
            </div>
          </div> */}

          {/* Left */}
          {/* <div className="relative z-10">
            <img
              src={Six}
              alt="6"
              className="w-24 h-24 object-cover rounded-full shadow-md border-4 border-gray-400 self-center xs:absolute md:mx-auto md:right-0 md:left-0"
            />
            <div className="relative pt-2 xs:pl-28 xs:pt-0 md:w-1/2 md:ml-0 md:mr-auto md:pl-0 md:pr-16">
              <div
                className="absolute inset-0 left-10 h-4 w-4 transform rotate-45 bg-[#343C5B] xs:top-11 xs:left-26 md:left-auto md:right-14"
                aria-hidden="true"
              ></div>
              <div className="bg-[#343C5B] p-6 rounded-md shadow-md text-gray-300">
                <h1 className="text-2xl font-bold pt-1">Project Title</h1>
                <span className="font-bold text-gray-200 text-lg trackng-wide">
                  Month Year
                </span>
                <p className="pt-2 text-base">
                  Lorem ipsum dolor sit amet consectetur adipisicing elit.
                  Ducimus rem tenetur nihil, maiores nisi tempore voluptate
                  nemo, libero voluptates soluta quas deleniti distinctio
                  excepturi illum aliquam expedita recusandae ab dolor?
                </p>
              </div>
            </div>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default Work;
